import { createSelector } from 'reselect';
import { preAssessmentDetails } from '@/selectors/merchant';

export const getDefaultState = createSelector(
  preAssessmentDetails,
  ({ products = [], sellingCountries = { all: [] } }) => {
    // If the user go back and add countries we need to add them here
    const baseObject = sellingCountries.all
      .filter(country => !products.find(p => p.country === country))
      .map(country => ({
        country,
        products: [],
      }));

    return {
      productsPerCountry: [...baseObject, ...products].reduce(
        (acc, { country, products: productsArr }) => ({
          ...acc,
          [country]: productsArr.reduce(
            (accProducts, { product, channels }) => ({
              ...accProducts,
              [product]: channels,
            }),
            {},
          ),
        }),
        {},
      ),
    };
  },
);
